import { render, staticRenderFns } from "./fileitem.vue?vue&type=template&id=079db162&scoped=true&"
import script from "./fileitem.vue?vue&type=script&lang=js&"
export * from "./fileitem.vue?vue&type=script&lang=js&"
import style0 from "./fileitem.vue?vue&type=style&index=0&id=079db162&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079db162",
  null
  
)

export default component.exports